export default __webpack_public_path__ + "static/company-allen-32428fe34114ca6b46dce6730710afc8.png";